import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'connectors'

export const schema = new schemas.Entity(collection)

type FetchQueryType = {
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: FetchQueryType) =>
    callApi(`${apiBase}/connectors/${id}`, schema)

type RemoveQueryType = {
  id: string
}

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: RemoveQueryType) =>
    callApi(`${apiBase}/connectors/${id}`, schema, {
      method: 'DELETE',
    })

type UpdateQueryType = {
  id: string
}

type UpdateBodyType = {
  connectorId: string
  userId?: string
}

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: UpdateQueryType, body: UpdateBodyType) =>
    callApi(`${apiBase}/connectors/${id}`, schema, {
      method: 'PUT',
      body,
    })

export const create =
  (callApi: CallApi, apiBase: string) => (_: unknown, url: string) =>
    callApi(`${apiBase}/connectors`, schema, {
      method: 'POST',
      body: {
        url,
      },
    })
